import VoucherHeading from './VoucherHeading';

export default VoucherHeading;
